import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { IAppointmentType } from '../types/appointment_interfaces';
import { ILocation, IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IAppointmentsLocationsQueryResult {
  locationsList: ILocation[];
  locationsInstructions: string;
  hasLocations: boolean;
  errorMessage: string;
}

export class AppointmentsLocationsQuery implements IQuery {
  private _result: IAppointmentsLocationsQueryResult;

  constructor(
    private ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {
    ORMMediator.registerQuery(
      this,
      ngAppointmentLocationsOrganizersDatasource,
      ngAppointmentLocationsOrganizersUsersource
    );
  }

  run(): this {
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    if (!!selectedType.instructions) {
      const locationsInstructions = selectedType.instructions.location;
      const locationsList: ILocation[] = _4.sortBy(this.ngAppointmentLocationsOrganizersDatasource.values(), 'name');
      const hasLocations = !_4.isEmpty(locationsList);
      const errorMessage = selectedType.instructions.location_error;
      this._result = {
        locationsList,
        locationsInstructions,
        hasLocations,
        errorMessage
      };
    }
    return this;
  }

  get result(): IAppointmentsLocationsQueryResult {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_locations_query.ts